var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 6,
    viewBox: "0 0 20 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 0.5C1.83696 0.5 1.20107 0.763393 0.732233 1.23223C0.263392 1.70107 0 2.33696 0 3C0 3.66304 0.263392 4.29893 0.732233 4.76777C1.20107 5.23661 1.83696 5.5 2.5 5.5C3.16304 5.5 3.79893 5.23661 4.26777 4.76777C4.73661 4.29893 5 3.66304 5 3C5 2.33696 4.73661 1.70107 4.26777 1.23223C3.79893 0.763393 3.16304 0.5 2.5 0.5ZM10 0.5C9.33696 0.5 8.70107 0.763393 8.23223 1.23223C7.76339 1.70107 7.5 2.33696 7.5 3C7.5 3.66304 7.76339 4.29893 8.23223 4.76777C8.70107 5.23661 9.33696 5.5 10 5.5C10.663 5.5 11.2989 5.23661 11.7678 4.76777C12.2366 4.29893 12.5 3.66304 12.5 3C12.5 2.33696 12.2366 1.70107 11.7678 1.23223C11.2989 0.763393 10.663 0.5 10 0.5ZM17.5 0.5C16.837 0.5 16.2011 0.763393 15.7322 1.23223C15.2634 1.70107 15 2.33696 15 3C15 3.66304 15.2634 4.29893 15.7322 4.76777C16.2011 5.23661 16.837 5.5 17.5 5.5C18.163 5.5 18.7989 5.23661 19.2678 4.76777C19.7366 4.29893 20 3.66304 20 3C20 2.33696 19.7366 1.70107 19.2678 1.23223C18.7989 0.763393 18.163 0.5 17.5 0.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.9d41e1e691d57568baba499574b2f56d.svg";
export { ForwardRef as ReactComponent };